export default __webpack_public_path__ + "static/media/445.762b9d2a.gif";